import lineStyle from './line.lineStyle'
import itemStyle from './line.itemStyle'
import areaStyle from './line.areaStyle'
import data from './line.data'
import label from './line.label'
import tooltip from './line.tooltip'

export default {
  name: "line",
  nickname: "折线图",
  desc: "line",
  type: "object",
  props: {
    smooth: {
      name: "smooth",
      nickname: "平滑",
      desc: "是否平滑曲线显示。",
      value: false,
      defaultValue: false,
    },
    lineStyle,
    itemStyle,
    areaStyle,
    data,
    label,
    tooltip,
    type: {
      name: "type",
      nickname: "类型",
      desc: "type",
      value: "",
      defaultValue: "",
      type: "pureValue",
    },
  },
}
